export default __webpack_public_path__ + "static/media/contato-form-baixo.1ebbd8e4.svg";